import { render } from "./Mobile.vue?vue&type=template&id=a8fb3134&scoped=true&lang=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"

import "./Mobile.vue?vue&type=style&index=0&id=a8fb3134&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8fb3134"]])

export default __exports__